module.exports = __webpack_public_path__ + "media/images/lesson_7/sebastiao_com_sucesso-7648a13644a82109c326ffbaded0d47d.png";